import { useEffect, useState, useCallback, useContext } from 'react';
import { Container } from '@mui/system';
import { loadStripeTerminal } from '@stripe/terminal-js';

import AdminNavbar from '../../components/AdminNavbar';
import ReaderDialog from './components/ReaderDialog';
import Checkout from '../../components/Checkout';
import AlertsContext from '../../AlertsContext';

const Terminal = () => {
  const { setAlert } = useContext(AlertsContext);
  const [currentTerminal, setCurrentTerminal] = useState();
  const [readers, setReaders] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [seletedReader, setSelectedReader] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const initStripteTerminal = async () => {
    const StripeTerminal = await loadStripeTerminal();

    const terminal = StripeTerminal.create({
      onFetchConnectionToken: async () => {
        let terminal
        try {
          const res = await fetch(process.env.REACT_APP_FN_URL + "/connectionToken");
          terminal = await res.json();
        } catch (e) {
          console.log(e);
          setAlert({
            type: "error",
            message: "Cant fetch connection token."
          })
        }
        return terminal.data.secret;
      },
      onUnexpectedReaderDisconnect: () => {
        setAlert({
          type: "error",
          message: "Disconnected from reader"
        });
        // console.log("Disconnected from reader");
      },
    })

    setCurrentTerminal(terminal);
  };

  /**
   * NOTE: The server-driven integration is generally available in the United States and Canada.
   */
  const processTerminalIntent = useCallback(async (currentTerminal) => {
    try {
      const config = Number(process.env.REACT_APP_TERMINAL_SIMULATE) === 1 ? { simulated: true } : {};
      const discoverResult = await currentTerminal.discoverReaders(config);
      if (discoverResult.error) {
        // console.log('Failed to discover: ', discoverResult.error);
        setAlert({
          type: 'error',
          message: "Failed to discover."
        });
      } else if (discoverResult.discoveredReaders.length === 0) {
        // console.log('No available readers.');
        setAlert({
          type: 'warning',
          message: "No available readers."
        });
      } else {
        setReaders(discoverResult.discoveredReaders);
      }
    } catch (e) {
      console.log(e);
    }
  }, []);

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleSelectReader = async (reader) => {
    console.log(reader);
    const selectedReader = reader;
    setIsLoading(true);
    const connectedResult = await currentTerminal.connectReader(selectedReader);
    if (connectedResult.error) {
      // console.log('Failed to connect: ', connectedResult.error)
      setAlert({
        type: 'error',
        message: "Failed to connect."
      });
    } else {
      setSelectedReader(reader);
      // console.log('Connected to reader: ', connectedResult.reader.label);
    }
    setOpenDialog(false);
    setIsLoading(false);
  }

  useEffect(() => {
    initStripteTerminal();
  }, [])

  useEffect(() => {
    if (!!currentTerminal && Object.entries(currentTerminal).length > 0 && readers && readers?.length === 0) {
      processTerminalIntent(currentTerminal);
      setOpenDialog(true);
    }
  }, [currentTerminal, readers, processTerminalIntent]);

  return (<>
    <AdminNavbar />
    <Container component="main" maxWidth="xs">
      {
        seletedReader && <Checkout terminal={currentTerminal} seletedReader={seletedReader} />
      }
      <ReaderDialog
        readers={readers}
        open={openDialog}
        disabled={isLoading}
        onClose={handleClose}
        onSelectReader={handleSelectReader}
      />
    </Container>
  </>)
};

export default Terminal;
